export const TRANSFORMER_TYPES = {
  set_label: {
    label: 'Set Label',
    description: 'Replace displayed value with text',
    component: 'SetLabelTransformer',
    defaults: { text: '' },
    apply(result, { text }) {
      return { ...result, label: text }
    }
  },

  template: {
    label: 'Template',
    description: 'Use pattern with {value} placeholder',
    component: 'TemplateTransformer',
    defaults: { pattern: '{value}' },
    apply(result, { pattern }, originalValue) {
      return {
        ...result,
        label: pattern.replace(/\{value\}/g, originalValue)
      }
    }
  },

  set_background_color: {
    label: 'Background Color',
    description: 'Set background color',
    component: 'ColorPickerTransformer',
    defaults: { color: null },
    apply(result, { color }) {
      return { ...result, backgroundColor: color }
    }
  },

  set_text_color: {
    label: 'Text Color',
    description: 'Set text/foreground color',
    component: 'ColorPickerTransformer',
    defaults: { color: null },
    apply(result, { color }) {
      return { ...result, textColor: color }
    }
  },

  set_tooltip: {
    label: 'Tooltip',
    description: 'Add hover text',
    component: 'TooltipTransformer',
    defaults: { text: '' },
    apply(result, { text }, originalValue) {
      return { ...result, tooltip: text.replace(/\{value\}/g, originalValue) }
    }
  }
}
